import React, { useEffect, useState } from "react";

import style from "./CallReports.module.css";
import axios from "axios";
import { baseUrl } from "../../data/baseURL";
import { format } from "date-fns-jalali";
import { useNavigate } from "react-router-dom";

export default function CallReports(props){
    let [currentPage, setCurrentPage] = useState(1);

    const navigate = useNavigate();

    let [allCallCounts, setAllCallCounts] = useState(0);

    let [data, setData] = useState([]);

    function goToNextPage(){
        if (currentPage * 10 < allCallCounts){
            setCurrentPage(currentPage + 1);
        }
    }

    function goToPastPage(){
        if (currentPage > 1){
            setCurrentPage(currentPage - 1);
        }
    }

    function goToLastPage(){
        let desPage = Math.floor(allCallCounts / 10) + 1;

        setCurrentPage(desPage);
    }

    useEffect(() => {
        axios.get(baseUrl + "/Calls/CallCount", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setAllCallCounts(res.data?.data)
        });
    }, [])

    useEffect(() => {
        axios.get(baseUrl + "/Calls/Calls", {
            params: {
                page: currentPage
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setData(res.data?.data)
        });
    }, [currentPage]);

    function getPriorityText(selectedPriority){
        switch(selectedPriority){
            case 0:
                return "آنی";
            case 1:
                return "فوری";
            case 2:
                return "مهم";
            case 3:
                return "عادی";
            default:
                return "-";
        }
    }

    function getStatusText(status){
        switch(status){
            case 0:
                return "در حال برسی";
            case 1:
                return "برسی شد";
            case 2:
                return "ارجاع داده شد";
            default:
                return "-";
        }
    }

    function deleteHandle(id){
        axios.delete(baseUrl + "/Calls", {
            params: {
                id: id
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            alert(res.data.message);
            window.location.reload();
        });
    }

    function changeStatus(id, currentStatus){
        axios.put(baseUrl + "/Calls", {
            id: id,
            status: currentStatus < 2? currentStatus + 1 : 0
        },{
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            alert(res.data.message);
            window.location.reload();
        });
    }

    function editHandle(id){
        navigate("/edit-call", {state: {
            id: id
        }});
    }

    return <>
        <div className={`${style.container}`}>
            <div className={`${style.header}`}>
                <div className={`${style.header_title}`}>
                    گزارشات تماس ها
                </div>
            </div>
            <div className={`${style.content}`}>
                <div className={`${style.table}`}>
                    <div className={`${style.table_header}`}>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            وضعیت
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            تاریخ
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            نام
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            مسئله تماس
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            فوریت
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            اکشن ها
                        </div>
                    </div>
                    <div className={`${style.table_body}`}>
                        {
                            data.map((d) => {
                                return <div className={`${style.table_body_i}`}>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {getStatusText(d.status)}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {format(new Date(d.createdAt * 1000 || 0), "d MMMM yyyy")}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {d.callerName == ""? "-" : d.callerName}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {d.callReason}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {getPriorityText(d.priority)}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        <div className={`${style.table_actions}`}>
                                            <div className={`${style.table_actions_status}`} title="تغییر وضعیت" onClick={() => changeStatus(d.id, d.status)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M240 119c0 22.6-18.3 41-41 41H152V360c0 39.8 32.2 72 72 72s72-32.2 72-72V152c0-66.3 53.7-120 120-120s120 53.7 120 120V352h47c22.6 0 41 18.3 41 41c0 10.9-4.3 21.3-12 29l-83 83c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-83-83c-7.7-7.7-12-18.1-12-29c0-22.6 18.3-41 41-41h47V152c0-39.8-32.2-72-72-72s-72 32.2-72 72V360c0 66.3-53.7 120-120 120s-120-53.7-120-120V160H57c-22.6 0-41-18.3-41-41c0-10.9 4.3-21.3 12-29L111 7c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l83 83c7.7 7.7 12 18.1 12 29zM73.9 112l108.1 0L128 57.9 73.9 112zm384 288L512 454.1 566.1 400H457.9z"/></svg>
                                            </div>
                                            <div className={`${style.table_actions_edit}`} title="ویرایش" onClick={() => editHandle(d.id)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"/></svg>
                                            </div>
                                            <div className={`${style.table_actions_delete}`} title="حذف" onClick={() => deleteHandle(d.id)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"/></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                        { data.length == 0? <div className={`${style.table_body_item}`} style={{gridColumnStart: 1, gridColumnEnd: 4, width: "100%"}}>
                            بدون داده
                        </div> : <></>}
                    </div>
                </div>
                <div className={`${style.page}`}>
                    <div className={`${style.page_item}`} onClick={goToLastPage}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={`${style.page_icons}`}><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>
                    </div>
                    <div className={`${style.page_item}`} onClick={goToNextPage}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.page_icons}`}><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>
                    </div>
                    <div className={`${style.page_item} ${style.page_item_center}`}>
                        {currentPage}
                    </div>
                    <div className={`${style.page_item}`} onClick={goToPastPage}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.page_icons}`}><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>
                    </div>
                    <div className={`${style.page_item}`} onClick={() => setCurrentPage(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={`${style.page_icons}`}><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>
                    </div>
                </div>
            </div>
        </div>
    
    </>
}